module.exports = __webpack_public_path__ + "img/profile-team1.0cdab1a3.jpeg";